import React, {useState} from "react";
import { Table, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const ItemProfitLossTable = ({ printMode = false }) => {
  const { data, totals, loading } = useSelector(
    (state) => state.itemProfitLoss
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Item Name", dataIndex: "item_name" },
    { title: "Group", dataIndex: "group_name" },
    { title: "Category", dataIndex: "category_name" },
    {
      title: "Sold Amount",
      dataIndex: "sold_amount",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
    },
    {
      title: "Costing Amount",
      dataIndex: "costing_amount",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
    },
    // {
    //   title: "Replace Sold",
    //   dataIndex: "given_replace_amount",
    //   align: "right",
    //   render: (val) => Number(val || 0).toFixed(2),
    // },
    // {
    //   title: "Replace Costing",
    //   dataIndex: "given_replace_costing_amount",
    //   align: "right",
    //   render: (val) => Number(val || 0).toFixed(2),
    // },

{
  title: "Return Sold",
  dataIndex: "return_sold_amount",
  align: "right",
  render: (val) => Number(val || 0).toFixed(2),
},
{
  title: "Return Costing",
  dataIndex: "return_costing_amount",
  align: "right",
  render: (val) => Number(val || 0).toFixed(2),
},
    {
      title: "Profit",
      dataIndex: "item_profit",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
    },
    // !printMode && {
    //   title: "Actions",
    //   className: "no-print",
    //   render: () => (
    //     <Button
    //       type="link"
    //       icon={<PrinterOutlined style={{ color: "green" }} />}
    //     />
    //   ),
    // },
  ].filter(Boolean);
  if (printMode) {
  return (
    <table className="item-profit-print-table">
      <colgroup>
        <col style={{ width: "4%" }} />
        <col style={{ width: "24%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "11%" }} />
      </colgroup>

      <tbody>
        <tr className="item-profit-print-heading">
          <td>No.</td>
          <td>Item Name</td>
          <td>Group</td>
          <td>Category</td>
          <td style={{ textAlign: "right" }}>Sold Amount</td>
          <td style={{ textAlign: "right" }}>Costing Amount</td>
          <td style={{ textAlign: "right" }}>Return Sold</td>
          <td style={{ textAlign: "right" }}>Return Costing</td>
          <td style={{ textAlign: "right" }}>Profit</td>
        </tr>

        {data.map((row, index) => (
          <tr key={row.item_id || index}>
            <td>{index + 1}</td>
            <td>{row.item_name}</td>
            <td>{row.group_name}</td>
            <td>{row.category_name}</td>

            <td style={{ textAlign: "right" }}>
              {Number(row.sold_amount || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.costing_amount || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.return_sold_amount || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.return_costing_amount || 0).toFixed(2)}
            </td>

            <td style={{ textAlign: "right" }}>
              {Number(row.item_profit || 0).toFixed(2)}
            </td>
          </tr>
        ))}

        <tr className="item-profit-total-row">
          <td colSpan={4} style={{ textAlign: "right" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(totals.totalSold || 0).toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(totals.totalCosting || 0).toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(totals.totalReturnSold || 0).toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(totals.totalReturnCosting || 0).toFixed(2)}
          </td>

          <td style={{ textAlign: "right" }}>
            {Number(totals.totalProfit || 0).toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey="item_id"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      scroll={printMode ? undefined : { x: "max-content" }}
      summary={() => (
        <Table.Summary.Row style={{ background: "#e6f4ff", fontWeight: "bold" }}>
          <Table.Summary.Cell colSpan={4} align="right">
            Grand Total:
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {Number(totals.totalSold || 0).toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {Number(totals.totalCosting || 0).toFixed(2)}
          </Table.Summary.Cell>
          {/* <Table.Summary.Cell align="right">
            {Number(totals.totalReplaceSold || 0).toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {Number(totals.totalReplaceCosting || 0).toFixed(2)}
          </Table.Summary.Cell> */}
          <Table.Summary.Cell align="right">
            {Number(totals.totalReturnSold || 0).toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {Number(totals.totalReturnCosting || 0).toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {Number(totals.totalProfit || 0).toFixed(2)}
          </Table.Summary.Cell>
          {/* {!printMode && <Table.Summary.Cell />} */}
        </Table.Summary.Row>
      )}
    />
  );
};

export default ItemProfitLossTable;
